<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>资产报废单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content-caption dashed bg-white">
            <span>报废单信息</span>
        </div>
        <el-form :model="scrapVoucher" :rules="voucherInfo" ref="ruleForm" class="demo-ruleForm">
            <div class="simple-form flex col-2">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">机构信息</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="srcComName">
                            <el-input class="width-1-5x bottom-line" :disabled="true" v-model="scrapVoucher.comFullName"></el-input>
                            <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectSrcComName" v-if="!srcCheck"></i>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="showBizUnitWarehouse && !srcCheck">
                    <div class="form-label">
                        <label class="required">仓库</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="warehouseId">
                            <el-select v-model="warehouseId" @change="warehouseChange">
                                <el-option v-for="item in warehouseList" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">申请原因</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="applyDesc">
                            <el-input placeholder="请填写报废原因及数量说明" type="textarea" v-model="scrapVoucher.applyDesc" resize="both"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>成本中心</label>
                    </div>
                    <div class="form-value">
                        <span>{{ scrapVoucher.costCenterCode || '' }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label></label>
                    </div>
                    <div class="form-value">
                        <span><el-checkbox :disabled="true" v-model="scrapVoucher.autoMaskAsIdle">自动标记闲置</el-checkbox></span>
                    </div>
                </div>
            </div>
        </el-form>

        <div class="content-caption dashed">
            <span>资产信息</span>
            <div class="input-tip error fr font12">提示:一次报废数据最多500条</div>
        </div>
        <div class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="showDeviceListDlg()" v-if="!srcCheck">
                    <span>通用选择</span>
                </button>
                <el-button type="primary" @click="setStaff" v-if="scrapVoucher.itemList.length > 0">
                    <span>设置人员</span>
                </el-button>
                <el-button type="primary" @click="setScrapCause" v-if="scrapVoucher.itemList.length > 0 && !srcCheck">
                    <span>设置报废原因</span>
                </el-button>
            </div>
        </div>
        <div class="simple-row">
            <div class="right">
                <span class="mr10">报废金额：({{ scrapVoucher.splittedAmount || 0 }})</span>
                <span>已选择({{ (scrapVoucher.itemList || []).length }})</span>
            </div>
        </div>
        <div class="table-layout">
            <el-form :model="scrapVoucher" ref="deviceInfo">
                <el-table ref="multipleTable" :data="scrapVoucher.itemList.slice(startIndex, endIndex)" maxHeight="500" border tooltip-effect="dark" style="width: 100%" :header-cell-class-name="required">
                    <el-table-column align="left" prop="innerCode" width="180" label="资产编号" fixed>
                        <template slot-scope="rows">
                            <a class="swb-btn swb-btn-link" @click="viewAssetInfo(rows.row);">{{ rows.row.innerCode }}</a>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="innerNo" width="250" label="外部资产编码"></el-table-column>
                    <el-table-column prop="assetType" width="100" label="管理方式" align="center" fixed="left">
                        <template slot-scope="rows">
                            <span>{{ assetTypeMap[rows.row.assetType] }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="title" width="200" label="资产描述全称"></el-table-column>
                    <el-table-column align="left" prop="fixedSpec" width="160" label="规格"></el-table-column>
                    <el-table-column align="right" prop="assetNature" width="100" label="资产属性">
                        <template slot-scope="rows">
                            <span>{{ assetNatureMap[rows.row.assetNature] }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="splitible" width="100" label="控制方式">
                        <template slot-scope="rows">
                            <span>{{ rows.row.splitible ? '按金额' : '按数量' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="maxQuantity" width="100" label="可报废数量" :render-header="floatIcon">
                        <template slot-scope="rows">
                            <span>{{ rows.row.maxQuantity || 0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="quantity" width="100" label="报废数量">
                        <template slot-scope="rows">
                            <el-input class="text-right" type="number" min="1" :disabled="rows.row.assetType == 0 || rows.row.splitible || srcCheck" v-model="rows.row.quantity" @change="changeQuantity(rows.row)"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="orgWorth" width="80" label="资产原值(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.orgWorthKz != null">{{ rows.row.orgWorthKz.toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="orgWorth" width="80" label="资产净值(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.netWorthKz != null">{{ rows.row.netWorthKz.toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="splittedAmount" width="100" label="报废原值(元)">
                        <template slot-scope="rows">
                            <input style="width:90%" :disabled="!rows.row.splitible || rows.row.assetType == 0 || srcCheck" type="number" min="0" class="input-content-right" @change="changeSplittedAmount(rows.row);" v-model.number="rows.row.splittedAmount"/>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="netWorth" width="80" label="报废金额(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.netWorth != null">{{ rows.row.netWorth.toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="durableLife" width="100" label="使用年限(月)"></el-table-column>
                    <el-table-column align="right" prop="durableYears" width="100" label="已用年限(月)"></el-table-column>
                    <el-table-column align="center" prop="deprTiming" width="100" label="报废时效类型">
                        <template slot-scope="rows">
                            <span v-if="rows.row.deprTiming != null">{{ scrapDeprTimingMap[rows.row.deprTiming] }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="fiscalInTime" width="140" label="入账时间">
                        <template slot-scope="rows">
                            <span v-if="rows.row.fiscalInTime != null">{{ rows.row.fiscalInTime }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="scrapCause" width="160" label="报废原因">
                        <template slot-scope="rows">
                            <el-select v-model="rows.row.scrapCause" placeholder="请选择" :disabled="srcCheck">
                                <el-option v-for="item in devcScrapCauseList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <!--<el-table-column align="left" prop="fixedSpec" width="160" label="原因说明">-->
                    <!--<template slot-scope="rows">-->
                    <!--<el-input class="textarea-value" type="textarea" v-model="rows.row.memo"></el-input>-->
                    <!--</template>-->
                    <!--</el-table-column>-->
                    <el-table-column align="left" prop="departName" width="180" label="报废部门"></el-table-column>
                    <el-table-column align="left" prop="staffName" width="120" label="报废人"></el-table-column>
                    <el-table-column align="left" prop="comFullName" width="200" label="部门全称" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="tmpNo" width="250" label="系统编号"></el-table-column>

                    <el-table-column prop="devcCustTag1Val" :label="devcCustTag1.dispName" width="120" v-if="devcCustTag1.enabled == true">
                    </el-table-column>
                    <el-table-column prop="devcCustTag2Val" :label="devcCustTag2.dispName" width="120" v-if="devcCustTag2.enabled == true">
                    </el-table-column>
                    <el-table-column prop="devcCustTag3Val" :label="devcCustTag3.dispName" width="120" v-if="devcCustTag3.enabled == true">
                    </el-table-column>

                    <el-table-column align="right" width="150" label="清理费用" v-if="fiscalClearFlag">
                        <template slot-scope="rows">
                            <el-form-item :prop="'itemList.' + (startIndex + rows.$index) + '.theFee'" :rules="{validator: inputTheFee, trigger: 'blur'}">
                                <el-input class="input-content-right" type="text" v-model="rows.row.theFee" @change="changeTheFee(rows.row)"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="150" label="清理收入" v-if="fiscalClearFlag">
                        <template slot-scope="rows">
                            <el-form-item :prop="'itemList.' + (startIndex + rows.$index) + '.theInc'" :rules="{validator: inputTheInc, trigger: 'blur'}">
                                <el-input class="input-content-right" type="text" v-model="rows.row.theInc" @change="changeTheInc(rows.row)"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" width="140" label="操作" fixed="right">
                        <template slot-scope="rows">
                            <a class="swb-btn-link" @click="deleteDevice(rows.$index)" v-if="!srcCheck">移除</a>
                            <a class="swb-btn-link" @click="setStaffInfo(rows.$index)">设置人员</a>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-layout" style="overflow: hidden">
                    <el-pagination class="fr" background v-if="totalCount > 10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                                   layout="prev, pager, next, jumper, sizes, total"></el-pagination>
                </div>
            </el-form>
        </div>

        <div class="content-caption dashed">
            <span>备注信息</span>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">标题</label>
                </div>
                <div class="form-value width-2x">
                    <el-input placeholder="例如：XXX店（店号+店名）申请XX资产报废" type="textarea" v-model="scrapVoucher.digest" resize="both"></el-input>
                </div>
            </div>
        </div>
        <div class="content-caption dashed required">
            <span class="ml5">附件信息</span>
        </div>
        <a class="swb-btn swb-btn-small" @click="showDialogFile();">上传</a>
        <div class="file-view-list" v-if="scrapVoucher.scrapFileList != null && scrapVoucher.scrapFileList.length > 0">
            <div class="file-view-header">
                <div class="file-name">名称</div>
                <div class="file-opera">操作</div>
            </div>
            <template v-for="(fileInfo, index) in scrapVoucher.scrapFileList">
                <swb-file-item-li :trackKey="index" :fileName="fileInfo.name" :fileBrowseUrl="fileInfo.fileBrowseUrl" :fileDownloadUrl="fileInfo.fileBrowseUrl" :fileUuid="fileInfo.fileUuid" :deletable="true"
                                  :onDelete="deleteFile"></swb-file-item-li>
            </template>
        </div>
        <div class="form-toolbar align-center" style="padding: 0;">
            <button class="swb-btn swb-btn-small swb-btn-primary mr10" @click="prevStock">返回</button>
            <button class="swb-btn swb-btn-small" v-if="!autoApplyAndAudit && checkActionPerm('apply', null, scrapVoucher.comId)" @click="saveScrapVoucher(true)">申请</button>
            <button class="swb-btn swb-btn-small" @click="saveScrapVoucher(false)">保存</button>
        </div>
    </div>
</template>

<script>
import { Jqext, Utils } from '../../app.base'

let Toast = Jqext.Toast;

import { MsgBox, Routes, Vue } from '../../app.vues'
import { getDefaultPageSizes } from '../../app.conf'
import { showDevcSelectDlg } from '../devc/selectDlg'
import { openComStaffMainForSelectDlg } from '../orgStruct/selectDlg'
import { checkUserActionPerm, getDevcGroupNameByCatId, isSysRescFrozenIsAllowed, syncSetBreadcrumb } from '../index'
import { assetFiscalInfoDlg } from '../retailer/dialog'
import { showComActionPostSelectDlg } from '../merchant/showSelectDlg'
import { getMerchantBizParam } from '../asset/assetMain'
import { getMerchtAuditBpConfInfo, openAuditTypeDlg, openDingdingAuditViewDlg, openFeiShuAuditViewDlg, openOaAuditBpNodeDlg } from '../oaAudit/selectDlg'

import shopStockApi from '../../api/shopStock'
import userApi from '../../api/user'
import assetVchrApi from '../../api/assetVchr'
import shopDeviceApi from '../../api/shopDevc'
import oaAuditApi from '../../api/oaAudit'
import retailerApi from '../../api/retailer'
//
import SwbShopDeviceScrapVoucherApplyList from './ShopDeviceScrapVoucherApplyList'
import SwbShopDeviceScrapVoucherAuditList from './ShopDeviceScrapVoucherAuditList'
import SwbComnFilesUpload from '../ctrl/ComnFilesUpload';
import SwbFileItemLi from '../ctrl/FileItemLi';
import custTagMeataApi from '../../api/objTagConf';

Vue.regist(SwbShopDeviceScrapVoucherApplyList);

Routes.add(SwbShopDeviceScrapVoucherAuditList);

Vue.regist(SwbComnFilesUpload);

Vue.regist(SwbFileItemLi);

export default {
    name: 'swb-shop-device-scrap-voucher-save',
    path: '/shop/device/scrap/voucher/save',
    avlActions: '',
    avlScopes: 'retailer',
    notAsResc: true,
    authen: false,
    customBreadcrumb: true,
    desc: '报废单 - 制作',
    data: function () {
        let validateApplyDesc = function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback(new Error('请输入申请原因！'));
            } else if(value.length > 250) {
                callback(new Error('申请原因最大长度250个字符(现' + value.length + '个)'));
            } else {
                callback();
            }
        };
        let validateWarehouseId = function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback(new Error('请选择仓库'));
            } else {
                callback();
            }
        };
        return {
            autoApplyAndAudit: false,
            isAuditBpConfAvailable: false,
            needAssignAuditors: false,
            dingDingAuditFlag: false,
            feiShuAuditFlag: false,
            scrapVoucher: {
                theDate: new Date(),
                warehouseId: null,
                splittedAmount: 0,
                autoMaskAsIdle: true,
                itemList: [],
                scrapFileList: []
            },
            warehouseId: null,
            ioFlag: null,
            showDeviceFlag: true,
            showDurableFlag: true,
            warehouseList: [],
            merchantId: null,
            bizUnitId: null,
            comId: null,
            voucherId: null,
            acctEnterWayMap: {},
            //
            audtoApplyState: false,
            autoAuditPass: false,
            fiscalClearFlag: false,
            devcClearFlag: false,
            updateOrgNetWorthFlag: false,
            checkedIds: [],
            checkedBatchIds: [],
            devcScrapCauseList: [],
            assetTypeMap: getEnumMap('assetType', 'value2text'),
            assetNatureMap: getEnumMap('assetNature', 'value2text'),
            scrapDeprTimingMap: getEnumMap('scrapDeprTiming', 'value2text'),
            showBizUnitWarehouse: false,
            //
            voucherInfo: {
                applyDesc: [{validator: validateApplyDesc, trigger: 'blur'}],
                warehouseId: [{validator: validateWarehouseId, trigger: 'blur'}]
            },
            parentPath: null,
            selectComId: null,
            selectComName: null,
            scopeEntity: {},
            //
            srcScrapVoucher: null,
            //
            pageSize: getDefaultPageSizes().first(),
            pageSizes: getDefaultPageSizes(),
            pageNumber: 1,
            totalCount: 0,
            startIndex: 0,
            endIndex: 0,
            srcCheck: false,
            devcCustTag1: {
                dispName: '自定义标签1',
                itemList: [],
                enabled: false,
                refUsed: false
            },
            devcCustTag2: {
                dispName: '自定义标签2',
                itemList: [],
                enabled: false,
                refUsed: false
            },
            devcCustTag3: {
                dispName: '自定义标签3',
                itemList: [],
                enabled: false,
                refUsed: false
            }
        }
    },
    created: function () {
        let self = this;
        self.getCustTagMetaFields();

        let devcScrapCauseList = getEnumList('devcScrapCause');
        let scrapCauseList = [];
        devcScrapCauseList.forEach(function (item) {
            if(item.value != 9) {
                scrapCauseList.push(item);
            }
        });
        this.devcScrapCauseList = scrapCauseList;

        // 1、检查当前商户是否开启外部审批：获取已就绪的业务审批流、优先级为 seqNo。
        getMerchtAuditBpConfInfo('retailer.assets.scrap', false, function (auditBpConfInfo) {
            if(!Utils.isNoB(auditBpConfInfo)) {
                self.needAssignAuditors = Utils.isTrue(auditBpConfInfo.needAssignAuditors);
                self.dingDingAuditFlag = Utils.isTrue(auditBpConfInfo.chanel == 2); // 钉钉
                self.feiShuAuditFlag = Utils.isTrue(auditBpConfInfo.chanel == 3); // 飞书
                if(!self.dingDingAuditFlag && !self.feiShuAuditFlag) {
                    // 2、如果自建的业务审批流程、检查看商户OA对接点是否就绪
                    self.isMerchtAuditBpConfAvailable();
                }
            } else {
                // 走系统内部审批
            }
        });
        //
        this.parentPath = this.$route.query.parentPath;
        syncSetBreadcrumb('报废单 - 制作', this.parentPath);
        this.acctEnterWayMap = getEnumMap('acctEnterWay', 'value2text');
        //
        getMerchantBizParam('show.biz.unit.warehouse', function (result) { // 显示门店/机构的仓库： {}
            self.showBizUnitWarehouse = Utils.isTrue(result);
            if(Utils.isTrue(self.showBizUnitWarehouse)) {
                self.getWarehouseList();
            }
        });
        // 报废审核通过后自动执行清理/清除： {Boolean}//零售商
        getMerchantBizParam('auto.fiscal.clear.after.scrap.audit.approved', function (result) {
            self.fiscalClearFlag = Utils.isTrue(result);
        });
        getMerchantBizParam('auto.devc.clear.after.scrap.audit.approved', function (result) {
            self.devcClearFlag = Utils.isTrue(result);
        });
        //
        this.voucherId = this.$route.query.id || null;
        this.autoApplyAndAudit = Utils.isTrue(this.$route.query.autoApplyAndAudit);
        this.selectComId = this.$route.query.selectComId || null;
        this.selectComName = this.$route.query.selectComName || null;
        this.bizUnitId = this.$route.query.bizUnitId;
        if(!Utils.isNoB(this.selectComId)) {
            let comInfo = {};
            comInfo.id = this.selectComId;
            let isAllowed = isSysRescFrozenIsAllowed(self, comInfo);
            if(isAllowed) {
                this.scrapVoucher.comId = this.selectComId;
                this.scrapVoucher.comName = this.selectComName;
                this.scrapVoucher.comFullName = this.$route.query.selectComFullName;
                this.scrapVoucher.bizUnitName = this.$route.query.bizUnitName;
                this.scrapVoucher.bizUnitId = this.bizUnitId;
            }
        }
        if(!Utils.isNoB(this.bizUnitId)) {
            this.getShopInfo();
        }
        //
        this.getCurrentUserInfo();
        //
        if(!Utils.isNoB(this.voucherId)) {
            this.getShopDeviceScrapVoucherInfo();
        }
    },
    methods: {
        checkActionPerm: function (action, targetPostId, dataOwnerComId) {
            return checkUserActionPerm(SwbShopDeviceScrapVoucherApplyList.path, action, targetPostId, dataOwnerComId);
        },
        setPageList: function () {
            let totalRows = this.scrapVoucher.itemList || [];
            let start = (this.pageNumber - 1) * this.pageSize;
            let end = this.pageNumber * this.pageSize;
            if(totalRows.length != 0 && start > (totalRows.length - 1)) {
                this.pageNumber = this.pageNumber - 1;
                start = (this.pageNumber - 1) * this.pageSize;
                end = this.pageNumber * this.pageSize;
            }
            this.startIndex = start;
            this.endIndex = end;
            this.totalCount = totalRows.length;
        },
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.handlePageChange(1);
        },
        handlePageChange: function (val) {
            this.pageNumber = val;
            this.setPageList();
        },
        required: function (obj) {
            if(obj.column.property == 'scrapCause') {
                return 'star';
            }
        },
        // 额外费用校验
        inputTheFee: function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback();
            } else {
                if(!Utils.isMoneyStr(value)) {
                    callback(new Error('请输入正确的金额'));
                } else {
                    callback();
                }
            }
        },
        // 额外费用校验
        inputTheInc: function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback();
            } else {
                if(!Utils.isMoneyStr(value)) {
                    callback(new Error('请输入正确的金额'));
                } else {
                    callback();
                }
            }
        },
        // 设置清理状态
        setFiscalClear: function () {
            if(Utils.isFalse(this.fiscalClearFlag)) {
                this.devcClearFlag = false;
            } else {
                this.devcClearFlag = true;
            }
        },
        isMerchtAuditBpConfAvailable: function () {
            let self = this;
            oaAuditApi.isMerchtAuditBpConfAvailable({bizTypeCode: 'retailer.assets.scrap'}, function (result) {
                if(result.type == 'info') {
                    self.isAuditBpConfAvailable = result.data;
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getGoodsCatDevcGroupName: function (catId) {
            return getDevcGroupNameByCatId(catId);
        },
        // 单原值校验
        inputOrgWorth: function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback();
            } else {
                if(!Utils.isMoneyStr(value)) {
                    callback(new Error('请输入正确的金额'));
                } else {
                    callback();
                }
            }
        },
        // 单净值校验
        inputNetWorth: function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback();
            } else {
                if(!Utils.isMoneyStr(value)) {
                    callback(new Error('请输入正确的金额'));
                } else {
                    callback();
                }
            }
        },
        // 报废数量
        quantityChange: function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback(new Error('请输入报废数量'));
            } else {
                if(!Utils.isNaturalStr(value, true)) {
                    callback(new Error('请输入大于0的整数！'));
                } else {
                    callback();
                }
            }
        },
        changeQuantity: function (scrapItem) {
            let maxQuantity = scrapItem.maxQuantity;
            //
            let quantity = scrapItem.quantity;
            if(quantity > maxQuantity) {
                scrapItem.quantity = maxQuantity;
                Toast.show(scrapItem.title + '报废数量不能超过可报废数量:' + maxQuantity);
            }
            scrapItem.splittedAmount = ((parseFloat(scrapItem.orgWorthKz) / maxQuantity) * scrapItem.quantity).toFixed(2);
            //  计算-报废金额
            let params = [{
                splittedAmount: scrapItem.splittedAmount,
                deviceXId: scrapItem.deviceXId,
                tmpNo: scrapItem.tmpNo,
                assetType: scrapItem.assetType
            }];
            this.getScrapVoucherItemNetWorth(params, function (netWorthMaps) {
                scrapItem.netWorth = netWorthMaps[scrapItem.deviceXId];
            });
        },
        changeSplittedAmount: function (scrapItem) {
            let splittedAmount = parseFloat(parseFloat(scrapItem.splittedAmount).toFixed(2));
            //
            let orgWorthKz = parseFloat(scrapItem.orgWorthKz || 0);
            if(splittedAmount > orgWorthKz) {
                scrapItem.splittedAmount = scrapItem.orgWorthKz;
                Toast.show(scrapItem.title + '报废原值不能大于资产原值:' + orgWorthKz);
            }
            //  计算-报废金额
            let params = [{
                splittedAmount: scrapItem.splittedAmount,
                deviceXId: scrapItem.deviceXId,
                tmpNo: scrapItem.tmpNo,
                assetType: scrapItem.assetType
            }];
            this.getScrapVoucherItemNetWorth(params, function (netWorthMaps) {
                scrapItem.netWorth = netWorthMaps[scrapItem.deviceXId];
            });
        },
        changeTheFee(row) {
            let theFee = row.theFee;
            if(!Utils.isNoB(theFee) && Utils.isMoneyStr(theFee)) {
                row.theFee = parseFloat(parseFloat(theFee).toFixed(2));
            }
        },
        changeTheInc(row) {
            let theInc = row.theInc;
            if(!Utils.isNoB(theInc) && Utils.isMoneyStr(theInc)) {
                row.theInc = parseFloat(parseFloat(theInc).toFixed(2));
            }
        },
        getScrapVoucherItemNetWorth: function (params, callbackFunc) {
            let loading = MsgBox.loading();
            assetVchrApi.getShopDeviceScrapVoucherItemNetWorth(params, function (result) {
                loading.close();
                if(result.type == 'info') {
                    //
                    callbackFunc(result.data);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        //
        getShopInfo: function () {
            let self = this;
            let comInfo = {};
            comInfo.id = self.bizUnitId;
            let isAllowed = isSysRescFrozenIsAllowed(self, comInfo);
            if(isAllowed) {
                retailerApi.getRetailerCom({comId: self.bizUnitId}, function (result, jqXhr) {
                    if(result.type == 'info') {
                        let shopRetail = result.data;
                        let scrapVoucher = self.scrapVoucher || {};
                        scrapVoucher.comId = shopRetail.id;
                        scrapVoucher.comName = shopRetail.name;
                        scrapVoucher.comFullName = shopRetail.fullName;
                        scrapVoucher.bizUnitId = shopRetail.bizUnitId;
                        scrapVoucher.bizUnitName = shopRetail.bizUnitName;
                        scrapVoucher.costCenterCode = shopRetail.costCenterCode;
                        scrapVoucher.prftCenterCode = shopRetail.prftCenterCode;
                        //
                        self.scrapVoucher = Utils.merge({}, scrapVoucher);
                    } else {
                        MsgBox.error(result.message);
                    }
                });
            }
        },
        //
        getCurrentUserInfo: function () {
            let self = this;
            userApi.getUserInfoByContext({}, function (result, jqXhr) {
                if(result.type == 'info') {
                    let data = result.data;
                    self.scopeEntity = data.scopeEntity || {};
                    self.merchantId = data.scopeEntity.id;
                    self.comId = data.scopeEntity.comId;
                    if(Utils.isNoB(self.selectComId)) {
                        let comInfo = {};
                        comInfo.id = data.scopeEntity.comId;
                        let isAllowed = isSysRescFrozenIsAllowed(self, comInfo);
                        console.log('是否通过' + isAllowed);
                        if(isAllowed) {
                            self.selectComId = data.scopeEntity.comId;
                            self.selectComName = data.scopeEntity.comName;
                            //
                            self.scrapVoucher.comId = data.scopeEntity.comId;
                            self.scrapVoucher.comName = data.scopeEntity.comName;
                        }
                    }
                } else {
                    MsgBox.error(result.message);
                }
            });
        },
        // 上传附件信息
        showDialogFile: function () {
            let self = this;
            let scrapVoucher = self.scrapVoucher || [];
            let scrapFileList = scrapVoucher.scrapFileList || [];
            let theDlg = Vue.$showDialog({
                title: '附件上传',
                width: 500,
                height: 200,
                showCloseBtn: true,
                okVisible: false,
                template: '<swb-file-upload-list :selectFileUuids="selectFileUuids" @handle-change="getSelectFileList" ref="swb_file_upload_list"></swb-file-upload-list>',
                data: {
                    selectFileUuids: scrapFileList.pluck('fileUuid'),
                },
                okClicked: function () {
                    let result = this.$refs.swb_file_upload_list.getFilesResult() || {};
                    if(result.type === 'info') {
                        let resultData = result.data || {};
                        //
                        let selectFileList = resultData.selectFileList || [];
                        scrapVoucher.scrapFileList = Utils.merge([], selectFileList);
                        //
                        self.scrapVoucher = Utils.merge({}, scrapVoucher);
                        //
                        return true;
                    }
                    return false;
                },
                methods: {
                    getSelectFileList: function (selectFileList) {
                        let fileNames = selectFileList.pluck('name') || [];
                        let warnFlag = false;
                        let message = '';
                        for(let i = 0; i < scrapFileList.length; i++) {
                            let fileInfo = scrapFileList[i];
                            if(fileNames.indexOf(fileInfo.name) >= 0) {
                                warnFlag = true;
                                message = '文件名称[' + fileInfo.name + ']存在重复名称';
                                break;
                            }
                        }
                        if(warnFlag) {
                            MsgBox.warning(message);
                            return;
                        }
                        scrapFileList = scrapFileList.concat(selectFileList);
                        scrapVoucher.scrapFileList = Utils.merge([], scrapFileList);
                        //
                        self.scrapVoucher = Utils.merge({}, scrapVoucher);
                        theDlg.close();
                    }
                },
            });
        },
        deleteFile: function (index) {
            let scrapVoucher = this.scrapVoucher;
            let scrapFileList = scrapVoucher.scrapFileList || [];
            scrapFileList.removeAt(index.trackKey);
            scrapVoucher.scrapFileList = Utils.merge([], scrapFileList);
            //
            this.scrapVoucher = Utils.merge({}, scrapVoucher);
            return false;
        },
        // 选择调出机构
        selectSrcComName: function () {
            let self = this;
            Vue.$showDialog({
                title: '零售商机构-选择',
                width: 750,
                height: 600,
                showCloseBtn: true,
                template: '<swb-org-tree :isShowIcon="false" :isSelectThisLevel="isSelectThisLevel" :isRadio="isRadio" :isCom="isCom" :bizDepart = "true" :optionalState="[1,3]" :defalultState="[1,3]" ref="swb_org_tree"></swb-org-tree>',
                data: {
                    isRadio: true,
                    isCom: false,
                    isSelectThisLevel: true
                },
                okClicked: function () {
                    let result = this.$refs.swb_org_tree.getDlgResult() || {};
                    if(result.type == 'info') {
                        let shopRetail = result.data || {};
                        //
                        let scrapVoucher = self.scrapVoucher || {};
                        scrapVoucher.comId = shopRetail.id;
                        scrapVoucher.comName = shopRetail.name;
                        scrapVoucher.comFullName = shopRetail.fullName;
                        scrapVoucher.bizUnitId = shopRetail.bizUnitId;
                        scrapVoucher.bizUnitName = shopRetail.bizUnitName;
                        scrapVoucher.costCenterCode = shopRetail.costCenterCode;
                        scrapVoucher.prftCenterCode = shopRetail.prftCenterCode;
                        //
                        scrapVoucher.itemList = [];
                        self.scrapVoucher = Utils.merge({}, scrapVoucher);
                        self.srcScrapVoucher = Utils.merge({}, scrapVoucher);
                        //
                        self.setPageList();
                        //
                        if(Utils.isTrue(self.showBizUnitWarehouse)) {
                            self.getWarehouseList();
                        }
                    } else {
                        return false;
                    }
                }
            });
        },
        // 仓库信息
        getWarehouseList: function () {
            let self = this;
            let postData = {};
            let filterItems = {};
            let scrapVoucher = self.scrapVoucher;
            filterItems.locked = false;
            filterItems.retailerShopId = scrapVoucher.bizUnitId || null;
            postData.filterItems = filterItems;
            let theLoad = MsgBox.loading();
            shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
                theLoad.hide();
                if(result.type == 'info') {
                    let warehouseList = result.data || [];
                    if(warehouseList.length > 0) {
                        warehouseList.forEach(function (row) {
                            if(row.defaulted == true) {
                                self.scrapVoucher.warehouseId = row.id;
                                self.warehouseId = row.id;
                            }
                        })
                    }
                    self.warehouseList = warehouseList;
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 仓库变化事件
        warehouseChange: function (val) {
            let scrapVoucher = this.scrapVoucher;
            if(Utils.isNoB(this.voucherId)) {
                scrapVoucher.itemList = [];
            } else {
                if(val != scrapVoucher.warehouseId) {
                    scrapVoucher.itemList = [];
                }
            }
            scrapVoucher.departId = null;
            scrapVoucher.departName = null;
            scrapVoucher.staffId = null;
            scrapVoucher.staffName = null;
            scrapVoucher.scrapCause = null;
            scrapVoucher.memo = null;
            scrapVoucher.warehouseId = val;
            this.scrapVoucher = Utils.merge({}, scrapVoucher);
            //
            this.setPageList();
        },
        //
        getShopDeviceScrapVoucherInfo: function () {
            let self = this;
            let postData = {};
            postData.id = self.voucherId;
            assetVchrApi.getShopDeviceScrapVoucherById(postData, function (result) {
                if(result.type == 'info') {
                    let scrapVoucher = result.data;
                    let itemList = scrapVoucher.itemList || [];
                    //
                    let splittedAmount = 0;
                    let durableDevcVal = getEnumInfoWith('assetType', 'name', 'DurableDevc').value;
                    itemList.forEach(function (deviceItem) {
                        if(deviceItem.assetType == durableDevcVal) {
                            deviceItem.maxQuantity = deviceItem.fiscalQuantity - deviceItem.scrappedQuantity;
                        } else {
                            deviceItem.maxQuantity = 1;
                        }
                        if(deviceItem.assetNature == 1) {
                            splittedAmount = parseFloat((splittedAmount + deviceItem.netWorth).toFixed(2));
                        }
                    });
                    scrapVoucher.splittedAmount = splittedAmount;
                    self.warehouseId = scrapVoucher.warehouseId;
                    //
                    self.scrapVoucher = Utils.merge({}, scrapVoucher);
                    self.srcScrapVoucher = Utils.merge({}, scrapVoucher);
                    if(scrapVoucher.srcVoucherType == 21) {
                        self.srcCheck = true;
                    }
                    //
                    self.setPageList();
                } else {
                    MsgBox.warning(result.message);
                }
            })
        },
        // 选择资产
        showDeviceListDlg: function () {
            let self = this;
            //
            let scrapVoucher = self.scrapVoucher;
            let warehouseId = scrapVoucher.warehouseId;
            if(Utils.isTrue(self.showBizUnitWarehouse) && Utils.isNoB(warehouseId)) {
                Toast.show('请选择报废仓库');
                return false;
            }
            if(Utils.isNoB(scrapVoucher.comId)) {
                Toast.show('请选择机构信息！');
                return;
            }
            let itemList = scrapVoucher.itemList || [];
            let deviceXIds = itemList.pluck('deviceXId') || [];
            //
            let filter = {};
            filter.retailerComId = scrapVoucher.comId;
            filter.warehouseId = Utils.isTrue(self.showBizUnitWarehouse) ? warehouseId : null;
            filter.scrapped = 0;
            filter.fiscalLocked = false;
            filter.fiscalAcctFlag = 1;
            //
            showDevcSelectDlg({
                    filter: filter,
                    devcBizClolumType: getEnumInfoWith('devcBizClolumType', 'name', 'BaoFeiDlg').name,   // 报废选择
                    initSelectIds: deviceXIds,
                    selectAll: true
                }, function (deviceList) {
                    deviceList = self.makeScrapItems(deviceList);
                    itemList = itemList.concat(deviceList);
                    let itemLength = itemList.length;
                    let params = [];
                    for(let i = 0; i < itemLength; i++) {
                        params.push({
                            splittedAmount: itemList[i].splittedAmount,
                            deviceXId: itemList[i].deviceXId,
                            tmpNo: itemList[i].tmpNo,
                            assetType: itemList[i].assetType
                        });
                    }
                    let splittedAmount = 0;
                    //  计算-报废金额
                    self.getScrapVoucherItemNetWorth(params, function (netWorthMaps) {
                        for(let i = 0; i < itemLength; i++) {
                            itemList[i].netWorth = netWorthMaps[itemList[i].deviceXId];
                            //
                            let item = itemList[i];
                            if(item.assetNature == 1) {
                                splittedAmount = parseFloat((splittedAmount + item.netWorth).toFixed(2));
                            }
                        }
                        //
                        scrapVoucher.splittedAmount = splittedAmount;
                        scrapVoucher.itemList = Utils.merge([], itemList);
                        self.scrapVoucher = Utils.merge({}, scrapVoucher);
                        //
                        self.setPageList();
                    });
                }
            )
        },
        // 组装报废条目
        makeScrapItems: function (deviceList) {
            let self = this;
            let itemsList = [];
            if(!Utils.isNoB(deviceList)) {
                let scopeEntity = this.scopeEntity;
                let durableDevcVal = getEnumInfoWith('assetType', 'name', 'DurableDevc').value;
                deviceList.forEach(function (deviceItem) {
                    let item = {
                        deviceXId: deviceItem.id,
                        durable: Utils.isTrue(deviceItem.assetType == durableDevcVal),
                        assetType: deviceItem.assetType,
                        costCenterCode: deviceItem.costCenterCode,
                        vendorUkno: deviceItem.vendorUkno,
                        comFullName: deviceItem.retailerComFullName,
                        tmpNo: deviceItem.tmpNo,
                        catId: deviceItem.catId,
                        catName: deviceItem.catName,
                        skuId: deviceItem.skuId,
                        goodsId: deviceItem.goodsId,
                        brandId: deviceItem.brandId,
                        brandName: deviceItem.brandName,
                        title: deviceItem.title,
                        name: deviceItem.name,
                        model: deviceItem.model,
                        fixedSpec: deviceItem.fixedSpec,
                        modelSpec: deviceItem.modelSpec,
                        acctEnterWay: deviceItem.acctEnterWay,
                        assetNature: deviceItem.assetNature,
                        durableLife: deviceItem.durableLife,
                        innerDevcCatId: deviceItem.innerDevcCatId,
                        innerDevcCatName: deviceItem.innerDevcCatName,
                        orgWorth: deviceItem.orgWorth,
                        orgWorthKz: deviceItem.orgWorth,
                        netWorth: deviceItem.netWorth,
                        netWorthKz: deviceItem.netWorth,
                        inStkQuantity: deviceItem.inStkQuantity,
                        inStkAvQuantity: deviceItem.inStkAvQuantity,
                        fiscalQuantity: deviceItem.fiscalQuantity,
                        scrappedQuantity: deviceItem.scrappedQuantity,
                        maxQuantity: Utils.isTrue(deviceItem.assetType == durableDevcVal) ? (deviceItem.fiscalQuantity - deviceItem.scrappedQuantity) : 1,
                        quantity: 1,
                        splitible: deviceItem.splitible,
                        splittedAmount: Utils.isTrue(deviceItem.assetType == durableDevcVal) ? (parseFloat(deviceItem.orgWorth) / (deviceItem.fiscalQuantity - deviceItem.scrappedQuantity)).toFixed(2) : deviceItem.orgWorth,
                        inUseQuantity: deviceItem.inUseQuantity,
                        theUnit: deviceItem.theUnit,
                        batchNo: deviceItem.batchNo,
                        innerCode: deviceItem.innerCode,
                        svcNo: deviceItem.svcNo,
                        departId: scopeEntity.comId,
                        departName: scopeEntity.comName,
                        staffId: scopeEntity.staffId,
                        staffName: scopeEntity.staffName,
                        rented: false,
                        deprMonth: deviceItem.lastDeprMonth,
                        innerNo: deviceItem.innerNo,
                        fiscalInTime: deviceItem.fiscalInTime,
                        fiscalAcctFlag: deviceItem.fiscalAcctFlag,
                        devcCustTag1: deviceItem.devcCustTag1,
                        devcCustTag2: deviceItem.devcCustTag2,
                        devcCustTag3: deviceItem.devcCustTag3,
                        devcCustTag1Val: self.getDevcCustTagVal(1, deviceItem.devcCustTag1),
                        devcCustTag2Val: self.getDevcCustTagVal(2, deviceItem.devcCustTag2),
                        devcCustTag3Val: self.getDevcCustTagVal(3, deviceItem.devcCustTag3)
                    };
                    if(deviceItem.fiscalAcctFlag == 0) {
                        item.durableYears = deviceItem.durableYears || 0;
                    } else if(deviceItem.deprable) {
                        item.durableYears = (deviceItem.durableLife - deviceItem.leftMonths) || 0;
                    }
                    // 报废时效类型：已折旧完毕：到期报废。未折旧完毕：判断是否是当月为最后一个月，否：提前报废，是：到期报废
                    if(deviceItem.assetNature != 2) {
                        if(deviceItem.deprOver) {
                            item.deprTiming = getEnumInfoWith('scrapDeprTiming', 'name', 'Expired').value;  // 到期报废
                        } else {
                            // 剩余折旧月数 == 1 and 最后折旧月份为当月
                            const date = new Date();
                            date.setMonth(date.getMonth() - 1);
                            const year = date.getFullYear();
                            const month = date.getMonth() + 1; // 月份从0开始，需加1
                            const prevDateMonth = year * 100 + month; // 上个月，格式yyyyMM
                            if(deviceItem.leftMonths == 1 && deviceItem.lastDeprMonth === prevDateMonth) {
                                item.deprTiming = getEnumInfoWith('scrapDeprTiming', 'name', 'Expired').value;  // 到期报废
                            } else {
                                item.deprTiming = getEnumInfoWith('scrapDeprTiming', 'name', 'Early').value;  // 提前报废
                            }
                        }
                    }
                    itemsList.add(item);
                });
            }
            return itemsList;
        },
        // 移除普通设备
        deleteDevice: function (index) {
            let splittedAmount = 0;
            let theIndex = this.startIndex + index;
            let itemList = this.scrapVoucher.itemList || [];
            //
            itemList.splice(theIndex, 1);
            for(let i = 0; i < itemList.length; i++) {
                if(itemList[i].assetNature == 1) {
                    splittedAmount = parseFloat((splittedAmount + itemList[i].netWorth).toFixed(2));
                }
            }
            this.scrapVoucher.splittedAmount = splittedAmount;
            this.scrapVoucher.itemList = Utils.merge([], itemList);
            //
            this.setPageList();
        },
        // 设置报废原因
        setScrapCause: function () {
            let self = this;
            let scrapVoucher = this.scrapVoucher;
            let theDlg = Vue.$showDialog({
                title: '选择报废原因',
                width: 300,
                height: 200,
                showCloseBtn: true,
                template: '<div>' +
                    '<el-select v-model="scrapCause" placeholder="请选择">' +
                    '<el-option v-for="item in devcScrapCauseList" :key="item.value" :label="item.text" :value="item.value"></el-option>' +
                    '</el-select>' +
                    '</div>',
                data: {
                    scrapCause: null,
                    devcScrapCauseList: self.devcScrapCauseList
                },
                okClicked: function () {
                    let dlgSelf = this;
                    let itemList = scrapVoucher.itemList || [];
                    //
                    itemList.forEach(function (deviceAppturnItem) {
                        deviceAppturnItem.scrapCause = dlgSelf.scrapCause;
                    });
                    self.scrapVoucher.itemList = Utils.merge([], itemList);
                    //
                    self.setPageList();
                },
            });
        },
        // 设置人员
        setStaff: function () {
            let self = this;
            let scrapVoucher = this.scrapVoucher;
            let params = {bizUnitIds: [scrapVoucher.bizUnitId, this.scopeEntity.bizUnitId], defComId: scrapVoucher.comId};
            openComStaffMainForSelectDlg(params, function (result, theDlg) {
                theDlg.close();
                //
                let itemList = scrapVoucher.itemList || [];
                //
                itemList.forEach(function (deviceAppturnItem) {
                    deviceAppturnItem.departId = result.srcComId;
                    deviceAppturnItem.departName = result.srcComName;
                    deviceAppturnItem.staffId = result.id;
                    deviceAppturnItem.staffName = result.name;
                });
                self.scrapVoucher.itemList = Utils.merge([], itemList);
                //
                self.setPageList();
            });
        },
        // 单行设置人员
        setStaffInfo: function (index) {
            let self = this;
            let theIndex = this.startIndex + index;
            let scrapVoucher = self.scrapVoucher;
            let itemList = scrapVoucher.itemList || [];
            let params = {bizUnitIds: [scrapVoucher.bizUnitId, this.scopeEntity.bizUnitId], defComId: scrapVoucher.comId};
            openComStaffMainForSelectDlg(params, function (result, theDlg) {
                theDlg.close();
                let deviceAppturnItem = itemList[theIndex];
                deviceAppturnItem.departId = result.srcComId;
                deviceAppturnItem.departName = result.srcComName;
                deviceAppturnItem.staffId = result.id;
                deviceAppturnItem.staffName = result.name;
                //
                self.scrapVoucher.itemList = Utils.merge([], itemList);
                //
                self.setPageList();
            });
        },
        //返回
        prevStock: function () {
            let self = this;
            let srcScrapVoucher = self.srcScrapVoucher;
            let scrapVoucher = self.scrapVoucher;
            if(!Utils.isNoB(scrapVoucher.id) && !Utils.obj_val_equal(srcScrapVoucher, scrapVoucher, false, [])) {
                this.$confirm('存在未保存内容，是否确定关闭当前页面?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    self.$router.back(-1);
                }).catch(function () {
                });
            } else {
                self.$router.back(-1);
            }
        },
        // 保存固定资产领用/归还单
        saveScrapVoucher: function (submitFlag) {
            if(!Utils.repeatChecker.isValidFor('saveScrapVoucher', 1000)) {
                return;
            }
            let self = this;
            if(Utils.isTrue(this.autoApplyAndAudit)) {  // 登记自动申请审核
                this.audtoApplyState = true;
                this.autoAuditPass = true;
            }
            let scrapVoucher = self.scrapVoucher;
            if(Utils.isNoB(scrapVoucher.digest)) {
                Toast.show('请输入标题！');
                return;
            } else if(scrapVoucher.digest.length > 500) {
                Toast.show('标题最大长度500个字符(现' + scrapVoucher.digest.length + '个)');
                return;
            }
            if(Utils.isNoB(scrapVoucher.comId)) {
                Toast.show('请选择机构信息！');
                return;
            }
            if(Utils.isNoB(scrapVoucher.scrapFileList) || scrapVoucher.scrapFileList.length <= 0) {
                Toast.show('请上传附件信息！');
                return;
            }
            scrapVoucher.autoMaskAsIdle = Utils.isTrue(scrapVoucher.autoMaskAsIdle);
            self.$refs['ruleForm'].validate(function (valid) {
                if(valid) {
                    scrapVoucher.theDate = scrapVoucher.theDate.format('yyyy-MM-dd');
                    //
                    let itemList = scrapVoucher.itemList || [];
                    //
                    if(itemList.length <= 0) {
                        Toast.show('请选择资产');
                        return;
                    }
                    // 有资产的时候，进行资产相关的校验
                    let validateFailure = false;
                    self.$refs['deviceInfo'].validate(function (valid) {
                        if(valid) {
                            for(let i = 0; i < itemList.length; i++) {
                                let item = itemList[i];
                                if(Utils.isNoB(item.departId) || Utils.isNoB(item.staffId)) {
                                    validateFailure = true;
                                    Toast.show('请为资产[' + item.innerCode + ']设置人员!');
                                    break;
                                }
                                if(item.scrapCause == null) {
                                    validateFailure = true;
                                    Toast.show('请为资产[' + item.innerCode + ']设置报废原因!');
                                    break;
                                }
                                if(item.scrapCause == 9 && Utils.isNoB(item.memo)) {  // 其他：备注必填
                                    validateFailure = true;
                                    Toast.show('资产[' + item.innerCode + ']报废原因为：【其他】，请填写原因说明!');
                                    break;
                                }
                                if(item.assetType == 1) {
                                    if(Utils.isNoB(item.quantity)) {
                                        validateFailure = true;
                                        Toast.show('请设置报废数量');
                                        break;
                                    } else {
                                        let maxQuantity = item.maxQuantity;
                                        //
                                        if(!Utils.isNoB(item.splittedAmount) && item.splittedAmount <= 0 && item.quantity <= 0) {
                                            validateFailure = true;
                                            Toast.show('报废数量和报废原值不可同时为0');
                                            break;
                                        }
                                        if(item.quantity > maxQuantity) {
                                            validateFailure = true;
                                            Toast.show(item.title + '报废数量不能超过可报废数量:' + maxQuantity);
                                            break;
                                        }
                                    }
                                }
                                //
                                if (Utils.isNoB(item.theFee)) {
                                    item.theFee = 0;
                                }
                                if (Utils.isNoB(item.theInc)) {
                                    item.theInc = 0;
                                }
                            }
                        } else {
                            validateFailure = true;
                            Toast.show('请输入资产中相应的数据！');
                        }
                    });
                    if(validateFailure) {
                        return;
                    }
                    //
                    scrapVoucher.itemList = Utils.merge([], itemList);
                    //
                    self.setPageList();
                    if(itemList.length > 500) {
                        MsgBox.warning('【资产】支持最大单据级条目为500条！现' + itemList.length + '条！');
                        return;
                    }
                    if(!Utils.isTrue(self.isAuditBpConfAvailable)) {
                        scrapVoucher.audtoApplyState = self.audtoApplyState;
                        scrapVoucher.autoAuditPass = self.autoAuditPass;
                        scrapVoucher.fiscalClearFlag = self.fiscalClearFlag;
                        scrapVoucher.devcClearFlag = self.devcClearFlag;
                        scrapVoucher.updateOrgNetWorthFlag = self.updateOrgNetWorthFlag;
                    }
                    //
                    self.scrapVoucherSubmit(scrapVoucher, submitFlag);
                }
            });
        },
        scrapVoucherSubmit: function (scrapVoucher, submitFlag) {
            let self = this;
            if(submitFlag) {
                let submitVoucherDto = {
                    scrapVoucher: scrapVoucher,
                };
                if(self.dingDingAuditFlag) {
                    openAuditTypeDlg(null, function (auditType, theDlg) {
                        theDlg.close();
                        let dingDingFlag = Utils.isTrue(auditType);
                        if(dingDingFlag) {
                            let params = {
                                bizTypeCode: 'retailer.assets.scrap',
                            };
                            openDingdingAuditViewDlg(params, function (resultData) {
                                let departId = resultData.departId;
                                // 返回值：departId（部门ID）
                                submitVoucherDto.departId = departId || null;
                                submitVoucherDto.dingdingFlag = dingDingFlag;
                                //
                                self.doSubmitDeviceScrapVoucher(submitVoucherDto);
                            }, function (theDlg) {
                                theDlg.close();
                            });
                        } else {
                            // 申请内部审批
                            self.applyScrapVoucher(scrapVoucher);
                        }
                    })
                } else if(self.feiShuAuditFlag) {
                    // 飞书审批
                    // openAuditTypeDlg('feishu', function (auditType, theDlg) {
                    //     theDlg.close();
                    //     let feiShuFlag = Utils.isTrue(auditType);
                    //     if(feiShuFlag) {
                    //         let params = {
                    //             bizVoucherId: scrapVoucher.id,
                    //             bizVoucherNo: scrapVoucher.innerNo,
                    //             bizTypeCode: 'retailer.assets.scrap'
                    //         };
                    //         openFeiShuAuditViewDlg(params, function (resultData) {
                    //             let departId = resultData.departId;
                    //             //
                    //             submitVoucherDto.feiShuDepartId = departId || null;
                    //             submitVoucherDto.feiShuFlag = feiShuFlag;
                    //             //
                    //             self.doSubmitDeviceScrapVoucher(submitVoucherDto);
                    //         });
                    //     } else {
                    //         // 申请内部审批
                    //         self.applyScrapVoucher(scrapVoucher);
                    //     }
                    // });
                    let params = {
                        bizVoucherId: scrapVoucher.id,
                        bizVoucherNo: scrapVoucher.innerNo,
                        bizTypeCode: 'retailer.assets.scrap'
                    };
                    openFeiShuAuditViewDlg(params, function (resultData) {
                        let departId = resultData.departId;
                        let decisionBasisVal = resultData.decisionBasisVal;
                        let bizScenario = resultData.bizScenario;
                        //
                        submitVoucherDto.feiShuDepartId = departId || null;
                        submitVoucherDto.decisionBasisVal = decisionBasisVal || null;
                        submitVoucherDto.feiShuFlag = true;
                        submitVoucherDto.bizScenario = bizScenario || null;
                        //
                        self.doSubmitDeviceScrapVoucher(submitVoucherDto);
                    });
                } else if(self.isAuditBpConfAvailable) {
                    if(self.needAssignAuditors) {  // 需要选择审批人员
                        let params = {
                            bizTypeCode: 'retailer.assets.scrap'
                        };
                        openOaAuditBpNodeDlg(params, function (auditorList, theDlg) {
                            theDlg.close();
                            auditorList = auditorList || [];
                            if(auditorList.length <= 0) {
                                MsgBox.warning('无审批人员信息');
                                return;
                            }
                            submitVoucherDto.auditorList = Utils.merge([], auditorList);
                            //
                            self.doSubmitDeviceScrapVoucher(submitVoucherDto);
                        });
                    } else {
                        self.doSubmitDeviceScrapVoucher(submitVoucherDto);
                    }
                } else {
                    // 申请内部审批
                    self.applyScrapVoucher(scrapVoucher, submitFlag);
                }
            } else {
                this.scrapVoucherFunc(scrapVoucher, submitFlag);
            }
        },
        // 内部审批
        applyScrapVoucher: function (scrapVoucher, submitFlag) {
            let self = this;
            // 申请-内部审核（自动申请）
            let params = {
                bizUnitId: scrapVoucher.bizUnitId,
                voucherType: getEnumInfoWith('devcVoucherType', 'name', 'Scrap').value
            };
            let theLoad = MsgBox.loading();
            shopDeviceApi.getLastAuditInfo(params, function (resultX) {
                theLoad.hide();
                if(resultX.type == 'info') {
                    let auditInfo = resultX.data;
                    let initPostId = scrapVoucher.auditorPostId || null;
                    let auditorStaffId = scrapVoucher.auditorStaffId || null;
                    let auditorName = scrapVoucher.auditorName || null;
                    if(!Utils.isNoB(auditInfo) && auditInfo.postId > 0) {
                        initPostId = auditInfo.postId;
                        auditorStaffId = auditInfo.staffId;
                        auditorName = auditInfo.staffName;
                    }
                    showComActionPostSelectDlg({
                        title: '报废单申请 - 指定审核岗',
                        rescUrl: SwbShopDeviceScrapVoucherAuditList.path,
                        action: 'audit',
                        descLabel: '申请原因',
                        useParents: true,
                        expandedParents: true,
                        useDesc: false,
                        initPostId: initPostId,
                        showAuditor: !Utils.isNoB(auditorStaffId),
                        auditorStaffId: auditorStaffId,
                        auditorName: auditorName
                    }, function (resultData) {
                        resultData = resultData || {};
                        if(resultData.postId == null) {
                            Toast.show('请选择审核岗位', 3000, 'warning');
                            return false;
                        }
                        scrapVoucher.auditorPostId = resultData.postId;
                        scrapVoucher.auditorPostName = resultData.postName;
                        scrapVoucher.auditComId = resultData.comId;
                        scrapVoucher.auditComName = resultData.comName;
                        scrapVoucher.auditComLevel = resultData.comLevel;
                        scrapVoucher.auditorStaffId = resultData.auditorStaffId;
                        scrapVoucher.auditorName = resultData.auditorName;
                        scrapVoucher.audtoApplyState = true;
                        scrapVoucher.autoAuditPass = false;
                        //
                        self.scrapVoucherFunc(scrapVoucher, submitFlag);
                    }, this);
                } else {
                    MsgBox.warning(resultX.message);
                }
            });
        },
        //
        scrapVoucherFunc: function (scrapVoucher, submitFlag) {
            let self = this;
            let loading = MsgBox.loading();
            assetVchrApi.saveShopDeviceScrapVoucher(scrapVoucher, function (result) {
                loading.close();
                if(result.type == 'info') {
                    if(submitFlag || self.autoApplyAndAudit) {
                        let callback = function () {
                            self.$router.push({
                                path: self.parentPath
                            });
                        };
                        MsgBox.success('操作成功', {callback: callback});
                    } else {
                        let deviceScrapVoucher = result.data || {};
                        self.voucherId = deviceScrapVoucher.id;
                        //
                        self.getShopDeviceScrapVoucherInfo();
                        MsgBox.success('操作成功');
                    }
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 保存并申请接口
        doSubmitDeviceScrapVoucher: function (submitVoucherDto) {
            let self = this;
            let theLoadX = MsgBox.loading();
            assetVchrApi.doSubmitDeviceScrapVoucher(submitVoucherDto, function (resultX) {
                if(resultX.type == 'info') {
                    let callback = function () {
                        self.$router.push({
                            path: self.parentPath
                        });
                        if(!self.needAssignAuditors) {
                            let auditBpStateInfo = resultX.data || {};
                            if(Utils.isTrue(auditBpStateInfo.outerAuditFlag) && !Utils.isTrue(auditBpStateInfo.bpStarted) && auditBpStateInfo.auditState == 0) {
                                let params = {
                                    no: auditBpStateInfo.voucherNo
                                };
                                self.openOuterBpStartWin(params);
                            }
                        }
                    };
                    MsgBox.success('申请成功！', {callback: callback});
                } else {
                    // 申请失败时，保证不会出现重复单据，再次提交视为修改
                    let auditBpStateInfo = resultX.data || {};
                    if(!Utils.isNoB(auditBpStateInfo.scrapVoucher) && !Utils.isNoB(auditBpStateInfo.scrapVoucher.id)) {
                        let scrapVoucherInfo = Utils.merge({}, self.scrapVoucher);
                        scrapVoucherInfo.id = auditBpStateInfo.scrapVoucher.id;
                        //
                        self.scrapVoucher = Utils.merge({}, scrapVoucherInfo);
                    }
                    //
                    MsgBox.failure(resultX.message);
                }
                theLoadX.hide();
            });
        },
        openOuterBpStartWin: function (row) {
            let bizVoucherNo = row.no;
            if(!Utils.isNoB(row.innerNo)) {
                bizVoucherNo = row.innerNo;
            }
            // let pageUrl = 'https://qa-oa-bpm.wumart.com/portal/r/w?cmd=com.awspaas.user.apps.assets.swb.redirectCmd&dircmd=CLIENT_BPM_FORM_MAIN_PAGE_OPEN&user_id=00000194&processInstId=706a1357-1f27-4692-9d08-0a42c8e94de2&sig=d6dbd24ddff9c6f98516e2992fd5de35';
            let params = {};
            params.bizTypeCode = 'retailer.assets.scrap';
            params.bizVoucherNo = bizVoucherNo;
            params.auditSeqNo = row.auditSeqNo;
            oaAuditApi.getBpStartPageUrl(params, function (result) {
                if(result.type === 'info') {
                    let pageUrl = result.data;
                    Utils.openWindow(pageUrl);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 查看资产信息
        viewAssetInfo: function (row) {
            let params = {
                innerCode: row.innerCode,
                assetType: row.assetType
            };
            assetFiscalInfoDlg(params);
        },
//        <p class="text-align: right; margin: 0">可报废数量 =在账数量 - 已报废数量 - 锁定数量</p>
//            <p class="text-align: right; margin: 0">1）在账数量：当前资产已入账的总数量；</p>
//    <p class="text-align: right; margin: 0">2）已报废数量：当前资产已经报废完成的数量；</p>
//    <p class="text-align: right; margin: 0">3）锁定数量：当前资产被其他业务正在使用，系统锁定的数量；</p>
//    <i class="el-icon-question" slot="reference"></i>
        floatIcon: function (h, {column}) {
            const floatText1 = '可报废数量 =在账数量 - 已报废数量 - 锁定数量';
            const floatText2 = '在账数量：当前资产已入账的总数量';
            const floatText3 = '已报废数量：当前资产已经报废完成的数量';
            const floatText4 = '锁定数量：当前资产被其他业务正在使用，系统锁定的数量';
            return h(
                'div', [
                    h('span', column.label),
                    h('el-tooltip', {
                        props: {
                            placement: 'top'
                        }
                    }, [
                        h('div', {
                            slot: 'content',
                            style: {
                                'width': '300px',
                                whiteSpace: 'normal',
                                'margin-bottom': '2px'
                            }
                        }, floatText1),
                        h('div', {
                            slot: 'content',
                            style: {
                                'width': '300px',
                                whiteSpace: 'normal',
                                'margin-bottom': '2px'
                            }
                        }, floatText2),
                        h('div', {
                            slot: 'content',
                            style: {
                                'width': '300px',
                                whiteSpace: 'normal',
                                'margin-bottom': '2px'
                            }
                        }, floatText3),
                        h('div', {
                            slot: 'content',
                            style: {
                                'width': '300px',
                                whiteSpace: 'normal',
                                'margin-bottom': '2px'
                            }
                        }, floatText4),
                        h('i', {
                            class: 'el-icon-question',
                            style: 'margin-left:5px;'
                        })
                    ],)
                ]
            )
        },
        getCustTagMetaFields: function () {
            let self = this
            let param = [{tagMetaTableName: 'shop_device', tagMetaRole: 1}]
            custTagMeataApi.getCustTagMetaFields(param, function (result) {
                if(result.type == 'info') {
                    let tags = result.data
                    for(let i = 0; i < tags.length; i++) {
                        let tag = tags[i]
                        if(tag.fieldName == 'devcCustTag1') {
                            self.devcCustTag1 = {
                                dispName: tag.dispName,
                                itemList: tag.itemList,
                                enabled: tag.enabled,
                                refUsed: tag.refUsed
                            }
                        } else if(tag.fieldName == 'devcCustTag2') {
                            self.devcCustTag2 = {
                                dispName: tag.dispName,
                                itemList: tag.itemList,
                                enabled: tag.enabled,
                                refUsed: tag.refUsed
                            }
                        } else if(tag.fieldName == 'devcCustTag3') {
                            self.devcCustTag3 = {
                                dispName: tag.dispName,
                                itemList: tag.itemList,
                                enabled: tag.enabled,
                                refUsed: tag.refUsed
                            }
                        }
                    }
                } else {
                    MsgBox.warning(result.message)
                }
            });
        },
        getDevcCustTagVal(pos, val) {
            if(val && val != -1) {
                if(pos === 1) {
                    if(this.devcCustTag1.enabled == true) {
                        let items1 = this.devcCustTag1.itemList
                        for(var i = 0; i < items1.length; i++) {
                            let item1 = items1[i]
                            if(val == item1['id']) {
                                return item1['name']
                            }
                        }
                    }
                } else if(pos === 2) {
                    if(this.devcCustTag2.enabled == true) {
                        let items2 = this.devcCustTag2.itemList
                        for(var i = 0; i < items2.length; i++) {
                            let item2 = items2[i]
                            if(val == item2['id']) {
                                return item2['name']
                            }
                        }
                    }
                } else if(pos === 3) {
                    if(this.devcCustTag3.enabled == true) {
                        let items3 = this.devcCustTag3.itemList
                        for(var i = 0; i < items3.length; i++) {
                            let item3 = items3[i]
                            if(val == item3['id']) {
                                return item3['name']
                            }
                        }
                    }
                }
            }

            return null
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/scrapVoucher/ShopDeviceScrapVoucherSave.vue